import { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext/ThemeContext';

export const useThemeSettings = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeSettings must be used within a ThemeProvider');
  }
  return context;
};
